const State = cc.Enum({
    IDLE: 'IDLE',
    DRAW: 'DRAW'
});

cc.Class({
    extends: cc.Component,

    properties: {
        paylines: {
            type: cc.Node,
            default: []
        }
    },

    start () {
        this.state = State.IDLE;
        this.map = [];
    },

    showPayline (plIndex) {
        this.map.push(plIndex);
        this.paylines[plIndex].active = true;
        this.state = State.DRAW;
    },

    clearLines () {
        this.state = State.IDLE;
        this.map.forEach((plIndex) => {
            this.paylines[plIndex].active = false;
        });
        this.map.length = 0;
    },

    update () {

        if (this.state !== State.DRAW) {
            return;
        }

        // this.map.forEach((plIndex) => {
        //     this.paylines[plIndex].node.active = true;
        // });
    }

});
